module.exports = __webpack_public_path__ + "img/colonial-wire-cable-co.7a955991.png";